import { StaffApplication } from '../../lib/types/models/staff-application/staff-application'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffApplication(id: number) {
  return restApiClient.url(constructApiUrl(API.candidate.get.url, { id })).get<StaffApplication>()
}
